import { DOOR_TYPE as e } from "@project-rouge/rg-core";
function s(r) {
  const o = r.split("|")[0].toLowerCase()[2];
  return o === "d" ? e.Double : o === "s" ? e.Single : e.Misc;
}
export {
  s as getDoorTypeFromId
};
//# sourceMappingURL=index14.js.map
